import { Bot } from 'lucide-react';
import { useTranslation } from '@parentpath/i18n';

export function TypingIndicator() {
  const { t } = useTranslation('aiChat');

  return (
    <div className="flex gap-3 mb-4">
      {/* Avatar */}
      <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0">
        <Bot className="w-4 h-4 text-gray-600" />
      </div>

      {/* Typing Bubble */}
      <div className="bg-gray-100 rounded-2xl rounded-tl-sm px-4 py-3">
        <p className="text-xs font-medium text-gray-500 mb-1">{t('message.assistant')}</p>
        <div className="flex items-center gap-1">
          <div className="typing-dot w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
          <div className="typing-dot w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
          <div className="typing-dot w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
        </div>
      </div>
    </div>
  );
}
